import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwörter stimmen nicht überein');
      return;
    }

    if (password.length < 8) {
      toast.error('Passwort muss mindestens 8 Zeichen lang sein');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/auth/set-password`, {
        token,
        password,
      }, { withCredentials: true });

      toast.success('Passwort erfolgreich gesetzt');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Fehler beim Setzen des Passworts');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="card max-w-md">
          <p className="text-error">Ungültiger oder fehlender Token</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-subtle">
      <div className="card max-w-md w-full shadow-xl p-8">
        <div className="mb-6">
          <h1 className="text-2xl font-heading font-bold text-primary mb-2">Passwort setzen</h1>
          <p className="text-muted-foreground">Wählen Sie ein sicheres Passwort für Ihren Account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-medium mb-2">Neues Passwort</label>
            <input
              id="password"
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              data-testid="set-password-input"
            />
          </div>

          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium mb-2">Passwort bestätigen</label>
            <input
              id="confirmPassword"
              type="password"
              className="input-field"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
              data-testid="set-password-confirm-input"
            />
          </div>

          <button
            type="submit"
            className="btn-primary w-full mt-6"
            disabled={loading}
            data-testid="set-password-submit-button"
          >
            {loading ? 'Speichern...' : 'Passwort setzen'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SetPassword;
